import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types/http-error.type';
import { Order } from '@rd/types/order.type';

export const PollOrder = createAction(
  '[Polling] Poll Order',
  props<{ orderId: string }>(),
);

export const PollOrderSuccess = createAction(
  '[Polling] Poll Order Success',
  props<{ order: Order }>(),
);

export const PollOrderFail = createAction(
  '[Polling] Poll Order Fail',
  props<{ orderId: string; error: HttpError }>(),
);
